// extracted by css-extract-rspack-plugin
export default {"root":"SettingsNavMenu_root__TcmCS","title":"SettingsNavMenu_title__oqpQj"};